module.exports = __webpack_public_path__ + "img/header.27f387fd.png";